const firmware = {
    normalizeFirmwareVersion: (firmwareVersion: number, modemVersion: number): string => {
        if (modemVersion < 2002) {
            const ver = firmwareVersion.toString()
            if (ver.length >= 3) {
                const str1 = ver.substring(0, 1)
                const str2 = ver.substring(1, 2)
                const str3 = ver.substring(2, ver.length)
                return str1 + "." + str2 + "." + str3
            } else {
                return firmwareVersion.toString();
            }
        }
        else {
            // 00 00 00 00
            const patch = (firmwareVersion & 0x000000ff) >> 8 * 0;
            const minor = (firmwareVersion & 0x0000ff00) >> 8 * 1;
            const major = (firmwareVersion & 0x00ff0000) >> 8 * 2;
            return major + "." + minor + "." + patch;
        }
    }
};

export default firmware;